import { formatDateTime, formatMoney } from 'utils/formattedString';
import { Link } from 'react-router-dom';
import { Typography } from 'antd';
import i18n from 'i18n';
import { DynamicObjectType } from 'core/types/common';
import CustomerLabel from 'containers/Orders/components/CustomerLabel';
import {
  formatPaymentStatus,
  formatPaymentStatusColor,
} from 'utils/formatFieldUtils';
import {
  ORDER_EXCHANGE_STATUS,
  // EXCHANGE_CHANNEL,
} from 'constants/ordersExchange';
import StatusLabel from '../components/StatusLabel';

export const getColumns = (status) => {
  switch (status) {
    case ORDER_EXCHANGE_STATUS['AWAITING_CONFIRMATION']?.value:
      return [
        {
          name: 'exchangeNumber',
          title: 'Exchange No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-exchange/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'orderReturnId',
          title: 'Return No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-return/${record?.orderReturn?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{record?.orderReturn?.returnNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'newOrderId',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.newOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 120, color: '#AB2328' }}
              >
                #{record?.newOrder?.orderNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'originalOrder.orderNumber',
          title: 'Original Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.originalOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 200, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'createdAt',
          title: i18n.t('ordersExchange.createdTime'),
          render: (d) => <p style={{ minWidth: 150 }}>{formatDateTime(d)}</p>,
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'status',
          title: i18n.t('ordersExchange.exchangeStatus'),
          render: (d) => (
            <StatusLabel status={d} dataFull={ORDER_EXCHANGE_STATUS} />
          ),
          isDefault: true,
        },
        {
          name: 'newOrderItemsQuantity',
          title: i18n.t('ordersExchange.itemsExchanged'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'differenceAmount',
          title: i18n.t('ordersExchange.differenceAmount'),
          render: (d: number) => (
            <p className="min-w-[150px]">{formatMoney(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'paymentMethod',
          title: i18n.t('ordersExchange.pMethod'),
          render: (d, rc: DynamicObjectType) => (
            <div style={{ minWidth: 120 }}>{rc?.newOrder?.paymentType}</div>
          ),
          width: 120,
        },
        {
          name: 'paymentsStatus',
          title: i18n.t('ordersExchange.pStatus'),
          render: (d, rc: DynamicObjectType) => (
            <p
              style={{
                minWidth: 120,
                color: formatPaymentStatusColor(
                  rc?.newOrder?.payments?.[0]?.status,
                ),
              }}
            >
              {formatPaymentStatus(rc?.newOrder?.payments?.[0]?.status)}
            </p>
          ),
          width: 120,
        },
        {
          name: 'customer',
          title: i18n.t('ordersExchange.customerName'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
      ];
    case ORDER_EXCHANGE_STATUS['CONFIRMED']?.value:
      return [
        {
          name: 'exchangeNumber',
          title: 'Exchange No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-exchange/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'orderReturnId',
          title: 'Return No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-return/${record?.orderReturn?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{record?.orderReturn?.returnNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'newOrderId',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.newOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 120, color: '#AB2328' }}
              >
                #{record?.newOrder?.orderNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'originalOrder.orderNumber',
          title: 'Original Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.originalOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 200, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'confirmedAt',
          title: i18n.t('ordersExchange.confirmedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'status',
          title: i18n.t('ordersExchange.exchangeStatus'),
          render: (d) => (
            <StatusLabel status={d} dataFull={ORDER_EXCHANGE_STATUS} />
          ),
          isDefault: true,
        },
        {
          name: 'newOrderItemsQuantity',
          title: i18n.t('ordersExchange.itemsExchanged'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'differenceAmount',
          title: i18n.t('ordersExchange.differenceAmount'),
          render: (d: number) => (
            <p className="min-w-[150px]">{formatMoney(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'paymentMethod',
          title: i18n.t('ordersExchange.pMethod'),
          render: (d, rc: DynamicObjectType) => (
            <div style={{ minWidth: 120 }}>{rc?.newOrder?.paymentType}</div>
          ),
          width: 120,
        },
        {
          name: 'paymentsStatus',
          title: i18n.t('ordersExchange.pStatus'),
          render: (d, rc: DynamicObjectType) => (
            <p
              style={{
                minWidth: 120,
                color: formatPaymentStatusColor(
                  rc?.newOrder?.payments?.[0]?.status,
                ),
              }}
            >
              {formatPaymentStatus(rc?.newOrder?.payments?.[0]?.status)}
            </p>
          ),
          width: 120,
        },

        {
          name: 'customer',
          title: i18n.t('ordersExchange.customerName'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
      ];
    case ORDER_EXCHANGE_STATUS['RETURNING']?.value:
      return [
        {
          name: 'exchangeNumber',
          title: 'Exchange No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-exchange/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'orderReturnId',
          title: 'Return No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-return/${record?.orderReturn?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{record?.orderReturn?.returnNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'newOrderId',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.newOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 120, color: '#AB2328' }}
              >
                #{record?.newOrder?.orderNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'originalOrder.orderNumber',
          title: 'Original Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.originalOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 200, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'returnedAt',
          title: i18n.t('ordersExchange.returnedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'status',
          title: i18n.t('ordersExchange.exchangeStatus'),
          render: (d) => (
            <StatusLabel status={d} dataFull={ORDER_EXCHANGE_STATUS} />
          ),
          isDefault: true,
        },
        {
          name: 'newOrderItemsQuantity',
          title: i18n.t('ordersExchange.itemsExchanged'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'differenceAmount',
          title: i18n.t('ordersExchange.differenceAmount'),
          render: (d: number) => (
            <p className="min-w-[150px]">{formatMoney(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'customer',
          title: i18n.t('orders.customer'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
      ];
    case ORDER_EXCHANGE_STATUS['PROCESSING']?.value:
      return [
        {
          name: 'exchangeNumber',
          title: 'Exchange No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-exchange/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'orderReturnId',
          title: 'Return No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-return/${record?.orderReturn?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{record?.orderReturn?.returnNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'newOrderId',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.newOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 120, color: '#AB2328' }}
              >
                #{record?.newOrder?.orderNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'originalOrder.orderNumber',
          title: 'Original Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.originalOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 200, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'confirmedAt',
          title: i18n.t('ordersExchange.confirmedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'status',
          title: i18n.t('ordersExchange.exchangeStatus'),
          render: (d) => (
            <StatusLabel status={d} dataFull={ORDER_EXCHANGE_STATUS} />
          ),
          isDefault: true,
        },
        {
          name: 'newOrderItemsQuantity',
          title: i18n.t('ordersExchange.itemsExchanged'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'differenceAmount',
          title: i18n.t('ordersExchange.differenceAmount'),
          render: (d: number) => (
            <p className="min-w-[150px]">{formatMoney(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'paymentMethod',
          title: i18n.t('ordersExchange.pMethod'),
          render: (d, rc: DynamicObjectType) => (
            <div style={{ minWidth: 120 }}>{rc?.newOrder?.paymentType}</div>
          ),
          width: 120,
        },
        {
          name: 'paymentsStatus',
          title: i18n.t('ordersExchange.pStatus'),
          render: (d, rc: DynamicObjectType) => (
            <p
              style={{
                minWidth: 120,
                color: formatPaymentStatusColor(
                  rc?.newOrder?.payments?.[0]?.status,
                ),
              }}
            >
              {formatPaymentStatus(rc?.newOrder?.payments?.[0]?.status)}
            </p>
          ),
          width: 120,
        },
        {
          name: 'customer',
          title: i18n.t('orders.customer'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
      ];
    case ORDER_EXCHANGE_STATUS['COMPLETED']?.value:
      return [
        {
          name: 'exchangeNumber',
          title: 'Exchange No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-exchange/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'orderReturnId',
          title: 'Return No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-return/${record?.orderReturn?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{record?.orderReturn?.returnNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'newOrderId',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.newOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 120, color: '#AB2328' }}
              >
                #{record?.newOrder?.orderNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'originalOrder.orderNumber',
          title: 'Original Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.originalOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 200, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'completedAt',
          title: i18n.t('ordersExchange.completedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'status',
          title: i18n.t('ordersExchange.exchangeStatus'),
          render: (d) => (
            <StatusLabel status={d} dataFull={ORDER_EXCHANGE_STATUS} />
          ),
          isDefault: true,
        },
        {
          name: 'newOrderItemsQuantity',
          title: i18n.t('ordersExchange.itemsExchanged'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'differenceAmount',
          title: i18n.t('ordersExchange.differenceAmount'),
          render: (d: number) => (
            <p className="min-w-[150px]">{formatMoney(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'paymentMethod',
          title: i18n.t('ordersExchange.pMethod'),
          render: (d, rc: DynamicObjectType) => (
            <div style={{ minWidth: 120 }}>{rc?.newOrder?.paymentType}</div>
          ),
          width: 120,
        },
        {
          name: 'paymentsStatus',
          title: i18n.t('ordersExchange.pStatus'),
          render: (d, rc: DynamicObjectType) => (
            <p
              style={{
                minWidth: 120,
                color: formatPaymentStatusColor(
                  rc?.newOrder?.payments?.[0]?.status,
                ),
              }}
            >
              {formatPaymentStatus(rc?.newOrder?.payments?.[0]?.status)}
            </p>
          ),
          width: 120,
        },
        {
          name: 'customer',
          title: i18n.t('orders.customer'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
      ];
    case ORDER_EXCHANGE_STATUS['CANCELLED']?.value:
      return [
        {
          name: 'exchangeNumber',
          title: 'Exchange No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-exchange/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'orderReturnId',
          title: 'Return No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-return/${record?.orderReturn?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{record?.orderReturn?.returnNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'newOrderId',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.newOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 120, color: '#AB2328' }}
              >
                #{record?.newOrder?.orderNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'originalOrder.orderNumber',
          title: 'Original Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.originalOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 200, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'cancelledAt',
          title: i18n.t('ordersExchange.cancelledTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'status',
          title: i18n.t('ordersExchange.exchangeStatus'),
          render: (d) => (
            <StatusLabel status={d} dataFull={ORDER_EXCHANGE_STATUS} />
          ),
          isDefault: true,
        },
        {
          name: 'newOrderItemsQuantity',
          title: i18n.t('ordersExchange.itemsExchanged'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'differenceAmount',
          title: i18n.t('ordersExchange.differenceAmount'),
          render: (d: number) => (
            <p className="min-w-[150px]">{formatMoney(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'paymentMethod',
          title: i18n.t('ordersExchange.pMethod'),
          render: (d, rc: DynamicObjectType) => (
            <div style={{ minWidth: 120 }}>{rc?.newOrder?.paymentType}</div>
          ),
          width: 120,
        },
        {
          name: 'paymentsStatus',
          title: i18n.t('ordersExchange.pStatus'),
          render: (d, rc: DynamicObjectType) => (
            <p
              style={{
                minWidth: 120,
                color: formatPaymentStatusColor(
                  rc?.newOrder?.payments?.[0]?.status,
                ),
              }}
            >
              {formatPaymentStatus(rc?.newOrder?.payments?.[0]?.status)}
            </p>
          ),
          width: 120,
        },
        {
          name: 'customer',
          title: i18n.t('orders.customer'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
      ];
    default:
      return [
        {
          name: 'exchangeNumber',
          title: 'Exchange No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-exchange/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'orderReturnId',
          title: 'Return No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-return/${record?.orderReturn?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{record?.orderReturn?.returnNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'newOrderId',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.newOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 120, color: '#AB2328' }}
              >
                #{record?.newOrder?.orderNumber}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'originalOrder.orderNumber',
          title: 'Original Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/order-management/${record?.originalOrder?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 200, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'createdAt',
          title: i18n.t('ordersExchange.createdTime'),
          render: (d) => <p style={{ minWidth: 150 }}>{formatDateTime(d)}</p>,
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'status',
          title: i18n.t('ordersExchange.exchangeStatus'),
          render: (d) => (
            <StatusLabel status={d} dataFull={ORDER_EXCHANGE_STATUS} />
          ),
          isDefault: true,
        },
        {
          name: 'newOrderItemsQuantity',
          title: i18n.t('ordersExchange.itemsExchanged'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'differenceAmount',
          title: i18n.t('ordersExchange.differenceAmount'),
          render: (d: number) => (
            <p className="min-w-[150px]">{formatMoney(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'paymentMethod',
          title: i18n.t('ordersExchange.pMethod'),
          render: (d, rc: DynamicObjectType) => (
            <div style={{ minWidth: 120 }}>{rc?.newOrder?.paymentType}</div>
          ),
          width: 120,
        },
        {
          name: 'paymentsStatus',
          title: i18n.t('ordersExchange.pStatus'),
          render: (d, rc: DynamicObjectType) => (
            <p
              style={{
                minWidth: 120,
                color: formatPaymentStatusColor(
                  rc?.newOrder?.payments?.[0]?.status,
                ),
              }}
            >
              {formatPaymentStatus(rc?.newOrder?.payments?.[0]?.status)}
            </p>
          ),
          width: 120,
        },
        {
          name: 'customer',
          title: i18n.t('ordersExchange.customerName'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
        {
          name: 'confirmedAt',
          title: i18n.t('ordersExchange.confirmedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'processedAt',
          title: i18n.t('ordersExchange.orderProccessedTime'),
          render: (d) => (
            <p style={{ minWidth: 180 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'completedAt',
          title: i18n.t('ordersExchange.completedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'returnedAt',
          title: i18n.t('ordersExchange.returnedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'cancelledAt',
          title: i18n.t('ordersExchange.cancelledTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
      ];
  }
};
